export default "__VITE_ASSET__2efdbcae__"